import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogTopUpDriverView.propTypes = {
  driver: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogTopUpDriverView({ driver, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [amount, setAmount] = useState('');

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!Utils.isValid(amount)) {
      ToastHelper.showError('Vui lòng nhập số tiền');
      return;
    }
    if (_.toNumber(amount) <= 0) {
      ToastHelper.showError('Số tiền không hợp lệ');
      return;
    }
    setLoading(true);
    const res = await ChargeHelper.API.Driver.requestTopUpDriver(
      driver?.userId,
      _.toNumber(amount)
    );
    if (_.isBoolean(res) && res) {
      ToastHelper.showSuccess('Nạp tiền thành công');
      if (onDone) {
        onDone();
      }
    } else if (_.isString(res)) {
      ToastHelper.showError(res);
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2">
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Số tiền muốn nạp', true)}
            <KTFormInput
              type={KTFormInputType.currency}
              placeholder="Nhập số tiền"
              name="amount"
              value={amount}
              onChange={(value) => {
                setAmount(value);
              }}
              enableCheckValid={true}
              isValid={Utils.isValid(amount)}
              isTouched={readyToValidate}
            />
          </div>
        </div>
      </div>

      {/* footer */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 p-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Nạp tiền', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default DialogTopUpDriverView;
